// extracted by mini-css-extract-plugin
export var button = "newsletter-module--button--df0e7";
export var root = "newsletter-module--root--19725";